import React, { useState, useEffect } from 'react'; // Dodano useState i useEffect
import { Info, CheckCircle, AlertTriangle } from 'lucide-react';
import './Popup.css'; // Założenie, że style zostaną przeniesione lub dostosowane

// --- Komponent Popup ---
// Renderuje się zawsze, ale klasa 'visible' kontroluje widoczność i animację
const Popup = ({ config, onClose }) => {
  // Sprawdzamy, czy config jest prawidłowym obiektem i czy ma wymagane pola
  const isValidConfig = config && (typeof config === 'object') && (config.message || config.title);

  // Jeśli nie ma config lub jest nieprawidłowy, ustawiamy wartości domyślne, aby uniknąć błędów
  const {
    title,
    message,
    type = 'info',
    confirmText = 'OK',
    cancelText = 'Anuluj',
    onConfirm,
    onCancel,
    showInput = false, // Nowa opcja
    inputPlaceholder = '', // Nowa opcja
    initialInputValue = '' // Nowa opcja dla wartości początkowej inputu
  } = isValidConfig ? config : {};

  // Stan dla wartości pola input
  const [inputValue, setInputValue] = useState(initialInputValue);

  // Resetuj inputValue, gdy zmienia się config (np. otwiera się nowy popup)
  useEffect(() => {
    if (isValidConfig) {
      setInputValue(config.initialInputValue || ''); // Użyj wartości początkowej z configu lub pustej
    }
  }, [config, isValidConfig]); // Zależność od config i isValidConfig

  const handleOverlayClick = (e) => {
    // Zamykaj tylko jeśli kliknięto na overlay, a nie na content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = () => {
    // Przekaż wartość inputu do onConfirm, jeśli input jest widoczny
    if (onConfirm) {
      onConfirm(showInput ? inputValue : undefined); // Przekaż inputValue lub undefined
    }
    // Nie zamykaj popupa automatycznie, jeśli onConfirm zwróci false
    // (przydatne do walidacji w onConfirm)
    // if (onConfirm && onConfirm(showInput ? inputValue : undefined) !== false) {
    //   onClose();
    // } else if (!onConfirm) {
    //   onClose();
    // }
    // Na razie zostawiamy domyślne zamykanie, walidacja jest w ClientOrderPanel
     onClose();
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    onClose();
  };

  const Icon = {
    info: Info,
    success: CheckCircle,
    error: AlertTriangle,
    confirm: AlertTriangle, // Można użyć innej ikony dla potwierdzenia
    loading: () => <div className="popup-spinner"></div> // Prosty spinner CSS
  }[type];

  // Add 'visible' class only when config is valid
  const overlayClass = `popup-overlay ${isValidConfig ? 'visible' : ''}`;

  return (
    <div className={overlayClass} onClick={handleOverlayClick}>
      {/* Renderuj zawartość tylko jeśli popup ma być widoczny (config istnieje i jest prawidłowy), aby uniknąć błędów */}
      {isValidConfig && (
        <div className={`popup-content popup-${type}`}>
          <div className="popup-header">
            {Icon && <Icon size={24} className="popup-icon" />}
            <h3>{title || (type === 'error' ? 'Błąd' : type === 'success' ? 'Sukces' : 'Informacja')}</h3>
            <button onClick={onClose} className="popup-close-btn">&times;</button>
          </div>
          <div className="popup-body">
            {typeof message === 'string' ? <p>{message}</p> : message}
            {/* Dodajemy warunkowe renderowanie inputu */}
            {showInput && (
              <input
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                placeholder={inputPlaceholder}
                className="popup-input" // Dodaj klasę do stylizacji
                autoFocus // Automatyczne ustawienie fokusa
              />
            )}
          </div>
          <div className="popup-footer">
            {type === 'confirm' ? (
              <>
                <button onClick={handleConfirm} className="popup-btn popup-btn-confirm">
                  {confirmText}
                </button>
                <button onClick={handleCancel} className="popup-btn popup-btn-cancel">
                  {cancelText}
                </button>
              </>
            ) : type !== 'loading' ? (
               <button onClick={onClose} className="popup-btn popup-btn-confirm">
                 {confirmText}
               </button>
            ) : null /* Brak przycisku dla loading */}
          </div>
        </div>
      )}
    </div>
  );
};

export default Popup;
